import axios from 'axios';
import { BASE_SETTINGS_URL } from '../components/constants';
import { authHeaders } from '../utils/authHeaders';

export const createAIProfile = async (aiProfileData) => {
    try {
        const response = await axios.post(`${BASE_SETTINGS_URL}/aiprofile`, aiProfileData, authHeaders());
        return response.data;
    } catch (error) {
        console.error('Error creating AI Profile:', error);
        throw error;
    }
};

export const updateAIProfile = async (aiProfileData) => {
    try {
        const response = await axios.put(`${BASE_SETTINGS_URL}/aiprofile`, aiProfileData, authHeaders());
        return response.data;
    } catch (error) {
        console.error('Error updating AI Profile:', error);
        throw error;
    }
};

export const fetchAIProfiles = async () => {
    try {
        const response = await axios.get(`${BASE_SETTINGS_URL}/aiprofiles`, authHeaders());
        return response.data;
    } catch (error) {
        console.error('Error fetching AI Profiles:', error);
        throw error;
    }
};

export const fetchAIProfileByTask = async (taskId) => {
    try {
        const response = await axios.get(`${BASE_SETTINGS_URL}/aiprofile/task/${taskId}`, authHeaders());
        return response.data;
    } catch (error) {
        if (error.response?.status === 404) return null;
        console.error('Error fetching AI Profile by task:', error);
        throw error;
    }
};

export const deleteAIProfile = async (aiProfileId) => {
    try {
        const response = await axios.delete(`${BASE_SETTINGS_URL}/aiprofile`, {
            ...authHeaders(),
            data: { id: aiProfileId },
        });
        return response.data;
    } catch (error) {
        console.error('Error deleting AI Profile:', error);
        throw error;
    }
};
